import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import $ from 'jquery';
import { toast } from 'react-toastify';
import axiosInstance from '../../config/axiosInterceptor';

const AddPlan = () => {
    const navigate = useNavigate();
    const [themes, setThemes] = useState([]);
    const [frames, setFrames] = useState([]);
    const [vips, setVips] = useState([]);
    const [selectedTheme, setSelectedTheme] = useState('');
    const [selectedFrame, setSelectedFrame] = useState('');
    const [selectedVips, setSelectedVips] = useState([]);
    const [rs, setRs] = useState(0);
    const [SGST, setSGST] = useState(0);
    const [CGST, setCGST] = useState(0);
    const [total, setTotal] = useState(0);
    const [offerFrom, setOfferFrom] = useState(0);
    const [offerTo, setOfferTo] = useState(0);
    const [offerType, setOfferType] = useState('coins');
    const [offerActive, setOfferActive] = useState(false);

    useEffect(() => {
        const fetchAssets = async () => {
            try {
                const themeRes = await axiosInstance.get(`/admin/plan/getPlanAssets?type=1`);
                const frameRes = await axiosInstance.get(`/admin/plan/getPlanAssets?type=0`);
                const vipRes = await axiosInstance.get(`/admin/plan/getPlanAssets?type=2`);
                if (themeRes.data.success) setThemes(themeRes.data.data);
                if (frameRes.data.success) setFrames(frameRes.data.data);
                if (vipRes.data.success) setVips(vipRes.data.data || []);
            } catch (error) {
                toast.error("Error fetching assets: " + error.message);
            }
        };

        fetchAssets();
    }, []);

    useEffect(() => {
        const numericRs = parseFloat(rs) || 0;
        const numericSGST = parseFloat(SGST) || 0;
        const numericCGST = parseFloat(CGST) || 0;
        setTotal(numericRs + numericSGST + numericCGST);
    }, [rs, SGST, CGST]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const title = $("input[name='title']").val();
        const coins = $("input[name='coins']").val();

        if (!title || !coins || !rs) {
            if (!title) $('.form-error1').html("This field cannot be empty");
            if (!coins) $('.form-error2').html("This field cannot be empty");
            if (!rs) $('.form-error3').html("This field cannot be empty");
            return;
        }

        const payload = {
            title,
            coins,
            rs,
            SGST,
            CGST,
            total,
            theme: selectedTheme,
            frame: selectedFrame,
            vips: selectedVips,
            offer: {
                from: offerFrom,
                to: offerTo,
                type: offerType,
                active: offerActive
            }
        };

        try {
            const res = await axiosInstance.post(`${process.env.REACT_APP_BASEURL5}/admin/plan/createPlan`, { data: payload });
            if (res.data.success === 1) {
                toast.success(res.data.message);
                setTimeout(() => navigate('/admin/managePlan'), 1000);
            } else {
                toast.error(res.data.message);
            }
        } catch (err) {
            toast.error(err.message);
        }
    };

    const toggleVip = (vipId) => {
        setSelectedVips(prev =>
            prev.includes(vipId) ? prev.filter(id => id !== vipId) : [...prev, vipId]
        );
    };

    const ITEM_TYPE_LABELS = {
        frames: "Frame",
        entryEffects: "Entry Effect",
        bubbles: "Bubble",
        profileBadge: "Profile Badge",
        userBadge: "User Badge",
    };

    const renderVipPicker = () => (
        <div className="form-group">
            <label>Select VIPs (optional)</label>
            <p className="text-muted" style={{ fontSize: '13px', marginBottom: '8px' }}>
                Buying this plan grants each selected VIP and every item inside it.
            </p>
            {vips.length === 0 && (
                <p className="text-muted"><em>No VIPs with type PLAN available.</em></p>
            )}
            {vips.map(vip => (
                <div
                    key={vip._id}
                    style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '10px',
                        marginBottom: '8px',
                        background: selectedVips.includes(vip._id) ? '#f3f9ff' : '#fff'
                    }}
                >
                    <label style={{ fontWeight: 'normal', marginBottom: 0, cursor: 'pointer' }}>
                        <input
                            type="checkbox"
                            checked={selectedVips.includes(vip._id)}
                            onChange={() => toggleVip(vip._id)}
                            style={{ marginRight: '8px' }}
                        />
                        <strong>{vip.title || "VIP"}</strong>
                        {vip.valid ? ` - ${vip.valid} days` : ''}
                    </label>
                    <div style={{ marginLeft: '24px', marginTop: '6px' }}>
                        {vip.items && vip.items.length > 0 ? (
                            <>
                                <small className="text-muted">Includes:</small>
                                <ul style={{ marginBottom: 0, paddingLeft: '18px' }}>
                                    {vip.items.map(item => (
                                        <li key={item._id} style={{ fontSize: '13px' }}>
                                            {ITEM_TYPE_LABELS[item.itemType] || item.itemType}: {item.title || "-"}
                                        </li>
                                    ))}
                                </ul>
                            </>
                        ) : (
                            <small className="text-muted"><em>No items linked to this VIP yet.</em></small>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );

    const renderSelectedImage = (id, list, isFrame = false) => {
        const selected = list.find(item => item._id === id);
        if (!selected) return null;
        return (
            <img
                src={`${process.env.REACT_APP_BASEURL}${isFrame ? selected.thumbnail : selected.image}`}
                alt={selected.name || selected.title}
                style={{ height: '100px', marginTop: '10px' }}
            />
        );
    };

    return (
        <>
            <section className="content-header">
                <h1>Add Plan</h1>
                <ol className="breadcrumb">
                    <li><Link to="/admin"><i className="fa fa-dashboard"></i> Home</Link></li>
                    <li><Link to="/admin/managePlan">Manage Plan</Link></li>
                    <li className="active">Add Plan</li>
                </ol>
            </section>
            <section className="content">
                <div className="row">
                    <div className="col-md-12">
                        <form onSubmit={handleSubmit} id="form">
                            <div className="box box-warning">
                                <div className="box-header with-border">
                                    <h3 className="box-title">Add</h3>
                                </div>
                                <div className="box-body">
                                    <div className="form-group">
                                        <label>Title*</label>
                                        <input type="text" className="form-control" name="title" onChange={() => $('.form-error1').html('')} />
                                        <div className="form-error1 text-danger"></div>
                                    </div>
                                    <div className="form-group">
                                        <label>Coin*</label>
                                        <input type="number" className="form-control" name="coins" onChange={() => $('.form-error2').html('')} />
                                        <div className="form-error2 text-danger"></div>
                                    </div>
                                    <div className="form-group">
                                        <label>Rupees (INR)*</label>
                                        <input type="number" className="form-control" name="rs" value={rs} onChange={(e) => { setRs(e.target.value); $('.form-error3').html(''); }} />
                                        <div className="form-error3 text-danger"></div>
                                    </div>
                                    <div className="form-group">
                                        <label>SGST</label>
                                        <input type="number" className="form-control" value={SGST} onChange={(e) => setSGST(e.target.value)} />
                                    </div>
                                    <div className="form-group">
                                        <label>CGST</label>
                                        <input type="number" className="form-control" value={CGST} onChange={(e) => setCGST(e.target.value)} />
                                    </div>
                                    <div className="form-group">
                                        <label>Total Amount</label>
                                        <input type="number" className="form-control" value={total} readOnly />
                                    </div>

                                    <div className="form-group">
                                        <label>Select Theme</label>
                                        <select className="form-control" value={selectedTheme} onChange={(e) => setSelectedTheme(e.target.value)}>
                                            <option value="">-- Select Theme --</option>
                                            {themes.map(theme => (
                                                <option key={theme._id} value={theme._id}>
                                                    {theme.name ?? "THEME"} - {theme.valid} hours
                                                </option>
                                            ))}
                                        </select>
                                        {renderSelectedImage(selectedTheme, themes)}
                                    </div>

                                    <div className="form-group">
                                        <label>Select Frame</label>
                                        <select className="form-control" value={selectedFrame} onChange={(e) => setSelectedFrame(e.target.value)}>
                                            <option value="">-- Select Frame --</option>
                                            {frames.map(frame => (
                                                <option key={frame._id} value={frame._id}>
                                                    {frame.title ?? "FRAME"} - {frame.valid} hours
                                                </option>
                                            ))}
                                        </select>
                                        {renderSelectedImage(selectedFrame, frames, true)}
                                    </div>

                                    {renderVipPicker()}

                                    <div className="form-group">
                                        <label>
                                            <input
                                                type="checkbox"
                                                checked={offerActive}
                                                onChange={(e) => setOfferActive(e.target.checked)}
                                                style={{ marginRight: '8px' }}
                                            />
                                            Enable Offer
                                        </label>
                                    </div>
                                    {offerActive && (
                                        <>
                                            <div className="form-group">
                                                <label>Offer Type</label>
                                                <select className="form-control" value={offerType} onChange={(e) => setOfferType(e.target.value)}>
                                                    <option value="coins">Coins</option>
                                                    <option value="percentage">Percentage</option>
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label>Offer From</label>
                                                <input type="number" className="form-control" value={offerFrom} onChange={(e) => setOfferFrom(e.target.value)} />
                                            </div>
                                            <div className="form-group">
                                                <label>Offer To</label>
                                                <input type="number" className="form-control" value={offerTo} onChange={(e) => setOfferTo(e.target.value)} />
                                            </div>
                                            <p className="text-muted">
                                                {offerType === 'coins'
                                                    ? `A random amount between ${offerFrom} and ${offerTo} bonus coins will be added on purchase.`
                                                    : `A random ${offerFrom}% to ${offerTo}% bonus of plan coins will be added on purchase.`}
                                            </p>
                                        </>
                                    )}
                                    <div className="form-group">
                                        <button type="reset" className="btn btn-danger">Cancel</button>
                                        <input type="submit" className="btn btn-success pull-right" value="Submit" />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </>
    );
};

export default AddPlan;
